import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum, PaymentMethodEnum } from '@systemeio/types';
import { DigitalProductSourceEnum } from 'modules/digital-product/enums/digital-product-source-enum';
import { DigitalProductChangeInterface } from 'modules/digital-product/types/digital-product-interface';
import OfferProductTypeSelector from 'modules/funnels/funnel/components/offer-settings/offer-product-type-selector';
import { DigitalProductSelectorCard } from 'modules/funnels/funnel/components/step-configuration-tab/digital-product-selector/components/digital-product-selector-card';
import { DigitalOfferEditInterface, DigitalOfferViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/digital-offer-interface';
import { PhysicalOfferEditInterface, PhysicalOfferViewInterface } from 'modules/funnels/funnel/components/step-configuration-tab/offer-form-configuration-tab/types/physical-offer-interface';
import PhysicalProductSelectorCard from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/components/physical-product-selector-card';
import { OfferTypeEnum } from 'modules/funnels/funnel/enums/offer-type-enum';
import React, { useState } from 'react';
interface Props {
  onSaveDigital: (data: DigitalOfferEditInterface['digitalProduct']) => Promise<void>;
  currency: CurrencyEnum;
  onSavePhysical: (data: PhysicalOfferEditInterface['product']) => Promise<void>;
  paymentMethods: PaymentMethodEnum[];
  product: PhysicalOfferViewInterface['product'];
  digitalProduct: DigitalOfferViewInterface['digitalProduct'];
  isBump?: boolean;
}
export function OfferProduct(t0) {
  const $ = _c(28);
  const {
    onSavePhysical,
    onSaveDigital,
    currency,
    paymentMethods,
    product,
    digitalProduct,
    isBump
  } = t0;
  const [draftProduct, setDraftProduct] = useState(null);
  const [draftDigitalProduct, setDraftDigitalProduct] = useState();
  const type = draftProduct ? OfferTypeEnum.physical : draftDigitalProduct || digitalProduct ? OfferTypeEnum.digital : product ? OfferTypeEnum.physical : undefined;
  let t1;
  if ($[0] !== onSavePhysical) {
    t1 = async data => {
      await onSavePhysical(data);
      setDraftProduct(null);
    };
    $[0] = onSavePhysical;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSavePhysical = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = data_0 => {
      setDraftDigitalProduct(undefined);
      setDraftProduct(data_0);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleAddPhysical = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = data_1 => {
      setDraftProduct(null);
      setDraftDigitalProduct(data_1);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleAddDigital = t3;
  const t4 = type === OfferTypeEnum.physical;
  const t5 = type === OfferTypeEnum.digital;
  let t6;
  if ($[4] !== currency || $[5] !== isBump || $[6] !== t4 || $[7] !== t5 || $[8] !== type) {
    t6 = <OfferProductTypeSelector type={type} currency={currency} isBump={isBump} onAddPhysical={handleAddPhysical} onAddDigital={handleAddDigital} hasPhysicalProduct={t4} hasDigitalProduct={t5} />;
    $[4] = currency;
    $[5] = isBump;
    $[6] = t4;
    $[7] = t5;
    $[8] = type;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== currency || $[11] !== draftProduct || $[12] !== handleSavePhysical || $[13] !== product || $[14] !== type) {
    t7 = type === OfferTypeEnum.physical && <PhysicalProductSelectorCard product={product} draftProduct={draftProduct} onSave={handleSavePhysical} onRemoveDraft={() => setDraftProduct(null)} currency={currency} />;
    $[10] = currency;
    $[11] = draftProduct;
    $[12] = handleSavePhysical;
    $[13] = product;
    $[14] = type;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== currency || $[17] !== digitalProduct?.id || $[18] !== draftDigitalProduct || $[19] !== isBump || $[20] !== onSaveDigital || $[21] !== paymentMethods || $[22] !== type) {
    t8 = type === OfferTypeEnum.digital && <DigitalProductSelectorCard attachedId={digitalProduct?.id ?? null} currency={currency} draftProduct={draftDigitalProduct} isBump={isBump} paymentMethods={paymentMethods} source={DigitalProductSourceEnum.Funnel} onAttach={onSaveDigital} onCleared={() => setDraftDigitalProduct(undefined)} />;
    $[16] = currency;
    $[17] = digitalProduct?.id;
    $[18] = draftDigitalProduct;
    $[19] = isBump;
    $[20] = onSaveDigital;
    $[21] = paymentMethods;
    $[22] = type;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = <>{t6}{t7}{t8}</>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}